import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { FeatureFlagService } from "../../_services/feature-flag/feature-flag.service";
import { toObservable } from "@angular/core/rxjs-interop";
import { map } from "rxjs";
import { RoutePage } from "../../app-routes.enum";
import { FEATURE_FLAGS } from "../../app.constants";

export const featureFlagGuard = (flagName: FEATURE_FLAGS) => (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const router = inject(Router);
  const activate = inject(FeatureFlagService).isFlagEnabled(flagName);

  return toObservable(activate).pipe(map((isEnabled) => (isEnabled ? true : router.createUrlTree([`/${RoutePage.InspectionList}`]))));
};
